import { render, staticRenderFns } from "./EdicionInvitadosAdmin.vue?vue&type=template&id=9d741104&"
import script from "./EdicionInvitadosAdmin.vue?vue&type=script&lang=js&"
export * from "./EdicionInvitadosAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports